import { createSlice } from "@reduxjs/toolkit";
import { getMaxPrice } from "store/actions/Shop.action";

const initialLog = {
  type: "",
  error: false,
  message: null,
  loading: false,
  success: false,
};

const initialState = {
  loading: false,
  shopType: "",
  success: false,
  message: null,
  logs: initialLog,
  maxPrice: 1000,
};

const slice = createSlice({
  name: "Shop",
  initialState,
  reducers: {
    selectShopType: (state, action) => {
      state.shopType = action.payload;
    },
    resetShopLogs: (state) => {
      state.maxPrice = 1000;
      state.logs = initialLog;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getMaxPrice.pending, (state) => {
        state.logs = {
          ...initialLog,
          loading: true,
          type: "getMaxPrice",
        };
      })
      .addCase(getMaxPrice.fulfilled, (state, action) => {
        state.maxPrice = action.payload.d;
        state.logs = { ...state.logs, success: true, loading: false };
      })
      .addCase(getMaxPrice.rejected, (state, action) => {
        state.logs = {
          ...state.logs,
          loading: false,
          error: action?.payload?.errors,
          message:
            action.payload?.m ||
            "Something went wrong getting rewards products.",
        };
      })
      .addCase("PURGE", (state, action) => {
        return initialState;
      });
  },
});

export const selectShopType = (payload) => (dispatch) => {
  dispatch(slice.actions.selectShopType(payload));
};

export const resetShopLogs = () => (dispatch) => {
  dispatch(slice.actions.resetShopLogs());
};

export const { reducer: Shop } = slice;

export default slice;
